export default __webpack_public_path__ + "device_alarm_pro_base_station.021acab2.png";